import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 获取看板设备
  cameraDevicegetBigDataInfoByProjectId(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/cameraDevice/getBigDataInfoByProjectId',
      method: 'get',
      params: params
    })
  },
  // 获取萤石云m3u8格式的视频播放地址
  getLiveAddress(data){
    return Axios({
        url: requestPrefix.projectUrl + '/cameraDevice/getLiveAddress',
        method:'post',
        data
    })
  },
  disableLiveAddress(data){
    return Axios({
        url:requestPrefix.projectUrl+'/cameraDevice/disableLiveAddress',
        method:'post',
        data
    })
  },
  // 查询设备是否在线
  hikvisionrunningState(id) {
    return Axios({
      url: requestPrefix.deviceServerUrl + '/hikvision/runningState/' + id,
      method: 'get'
    })
  },
  // 获取播放url
  getVsURL(deviceId, channel, protocol) {
    return Axios({
      url: requestPrefix.deviceServerUrl + '/video/getVsURL',
      method: 'get',
      params: { deviceId: deviceId, channel: channel, protocol: protocol }
    })
  },

  // 获取app
  mobileapplicationgetApps(params) {
    return Axios({
      url: requestPrefix.centerUrl + '/mobile/application/getApps',
      method: 'get',
      params: params
    })
  },
  // 获取app路由
  sysmenugetAppMenus(params) {
    return Axios({
      url: requestPrefix.centerUrl + '/sys/menu/getAppMenus',
      method: 'get',
      params: params
    })
  },

  // 当日访客统计
  kanbanprojectvisitorCountDay(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/kanban/project/visitorCountDay',
      method: 'get',
      params: params
    })
  },
  // 当日出勤统计
  kanbanprojectcheckinCountDay(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/kanban/project/checkinCountDay',
      method: 'get',
      params: params
    })
  },
  // 查询今日车辆
  kanbanprojecttodayCarTotal(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/kanban/project/todayCarTotal',
      method: 'get',
      params: params
    })
  },
  // 当日在场人数
  kanbanprojectcountOnSite(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/kanban/project/countOnSite',
      method: 'get',
      params: params
    })
  },
  // 劳务统计
  kanbanprojectstationCount(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/kanban/project/stationCount',
      method: 'get',
      params: params
    })
  },
  // 进出统计（工人-访客）
  kanbanprojectaccessTotal(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/kanban/project/accessTotal',
      method: 'get',
      params: params
    })
  },
  // 人员进出
  kanbanprojectaccessRecord(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/kanban/project/accessRecord',
      method: 'get',
      params: params
    })
  },

  // 进出统计
  kanbanprojectaccessCount(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/kanban/project/accessCount',
      method: 'get',
      params: params
    })
  },

  // 当日按照参建单位类别的考勤统计
  kanbanprojectcheckinByDeptType(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/kanban/project/checkinByDeptType',
      method: 'get',
      params: params
    })
  },

  // 访客统计（分月统计）
  kanbanprojectvisitorCount(params) {
    return Axios({
      url: requestPrefix.projectUrl + '/kanban/project/visitorCount',
      method: 'get',
      params: params
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/proInfoItem/index.js